/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Type_FaultyInputs */

const en_claim_type_faulty = /** @type {(inputs: Claim_Type_FaultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faulty product`)
};

/**
* | output |
* | --- |
* | "Faulty product" |
*
* @param {Claim_Type_FaultyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_type_faulty = /** @type {((inputs?: Claim_Type_FaultyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Type_FaultyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_type_faulty(inputs)
});